module.exports = __webpack_public_path__ + "img/心愿单.4d1f15df.png";